import { render, staticRenderFns } from "./wasteUCGraph.vue?vue&type=template&id=315b5541"
import script from "./wasteUCGraph.vue?vue&type=script&lang=js"
export * from "./wasteUCGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('315b5541')) {
      api.createRecord('315b5541', component.options)
    } else {
      api.reload('315b5541', component.options)
    }
    module.hot.accept("./wasteUCGraph.vue?vue&type=template&id=315b5541", function () {
      api.rerender('315b5541', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/env/waste/wasteUCGraph.vue"
export default component.exports